import React from 'react';
import Styles from './gridStyle.module.scss';
import Gridcontainer from './gridcontainer';
import Header from '../../components/header';
import Card, { CardTitle } from '../Card';
import { type } from 'os';
import { log } from 'console';
const GridPage = ({ criticalSeverityPatches }: any) => {
  // console.log('criticalSeverityPatches', criticalSeverityPatches);

  const rowArray = (criticalSeverityPatches?.thirdPartySoftware ?? []).map((item: any) => {
    const additionalInfo = item.additionalInfo ?? {};
    const softwareVersion = item.softwareVersion;
    const firstKey = Object.keys(additionalInfo)[0];

    const agentList = additionalInfo[softwareVersion] ?? additionalInfo[firstKey] ?? [];

    return {
      patchName: {
        name: item.software,
        image: require('../../icons/windows11h2.png'),
        packageIdentifier: item.packageIdentifier,
      },
      packageVersion: softwareVersion,
      remediated: `${item.remediatedPercentage ?? 0}%`,
      deviceImpactedTotal: `${item.impacted ?? 0}`,
      cveScore: item.cveScore,
      urlFilter: item.urlFilter ? `${item.urlFilter}?cveScore=${item.cveScore}` : undefined,
      latestVersionKey: firstKey ?? null,
      type: 'thirdParty',
      agentList,
    };
  });

  // console.log('rowArray',rowArray);

  const rowArray2 = (criticalSeverityPatches?.osUpdates ?? []).map((item: any) => {
    const updateId = item.updateId;
    const additionalInfo = item.additionalInfo ?? {};

    // Get agent list from additionalInfo
    let agentList = [];

    if (additionalInfo[updateId] && Array.isArray(additionalInfo[updateId])) {
      // Only map if the array has items and items are objects (not empty arrays)
      if (additionalInfo[updateId].length > 0 && additionalInfo[updateId][0]?.agentId) {
        agentList = additionalInfo[updateId].map((agent: any) => agent?.agentId).filter(Boolean);
      }
    }

    return {
      patchName: {
        name: item.updateDisplayName || item.osName,
        image: require('../../icons/windows11h2.png'),
      },
      remediated: `${item.remediatedPercentage ?? 0}%`,
      deviceImpactedTotal: `${item.impacted ?? 0}`,
      osUpdateId: item.updateId || item.osUpdateId,
      latestVersionKey: updateId,
      agentList,
      cveScore: item.cveScore,
      type: 'osUpdate',
    };
  });
  console.log('rowArray2', rowArray2);
  return (
    // <Card className="mt-[20px]">
    //   <CardTitle title="Top Critical Vulnerabilities"></CardTitle>

    <div className="flex flex-row gap-[20px] mt-[20px]">
      <Gridcontainer heading={'Top 5 Third-Party Applications'} rowArray={rowArray} />
      <Gridcontainer heading={'Top 5 OS Updates'} rowArray={rowArray2} />
    </div>
    // </Card>
  );
};

export default GridPage;
